module.exports = __webpack_public_path__ + "img/btn_menu_nh.5e6218ae.png";